module.exports = {
  CosAuth: require('./storageAuth/tc/cos-auth'),
};
